import React from 'react';
import { Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  description: string;
  secondLineDescription?: string;
};

export const HalfSizedContentBlock = ({ title, description, secondLineDescription }: Props) => (
  <Stack direction="row" gap={2}>
    <Typography variant="body3" fontWeight={700} sx={{ width: 1 / 2 }}>
      {title}
    </Typography>
    <Stack width={1 / 2}>
      <Typography variant="body3">{description}</Typography>
      {secondLineDescription && (
        <>
          <Typography variant="body3">{secondLineDescription}</Typography>
        </>
      )}
    </Stack>
  </Stack>
);
